import { createSlice } from '@reduxjs/toolkit';
import CreditCardRepository from 'repositories/loanOfficer/CreditCardRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'creditCard',
  repository: CreditCardRepository,
  slices: ['createCreditCard'],
});

const initialState = {
  ...restSlice.initialState,
};

const loanOfficerCreditCardSlice = createSlice({
  name: 'loanOfficerCreditCard',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default loanOfficerCreditCardSlice;
export const loanOfficerCreditCardReducer = loanOfficerCreditCardSlice.reducer;
export const loanOfficerCreditCardHooks = restSlice.hooks(loanOfficerCreditCardSlice, 'loanOfficerCreditCardReducer');



// WEBPACK FOOTER //
// ./src/reducers/slices/loanOfficer/creditCardSlice.js